import { SettingsComponent } from '../../components/settings/SettingsComponent';

export const SettingsContainer = () => {
  return <SettingsComponent />;
};
